import { RoutingRuleListTableRowData } from '../types';
import { getTargetDescription, getTargetTitle } from '../../../utils/targetBill';
import { RowTextCell } from './RowTextCell';

interface TargetBillCellProps {
    targetBill: RoutingRuleListTableRowData['targetBill'];
}

export const TargetBillCell: React.FC<TargetBillCellProps> = ({ targetBill }) => (
    <RowTextCell
        title={getTargetTitle(targetBill.targetType)}
        description={getTargetDescription(targetBill.targetType, targetBill.aggregationType)}
    />
);
